class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.header = document.querySelector('header');

        this.btnOpenMenu = this.header.querySelector('.btnOpenMenu')

        this.menu = this.header.querySelector('.menu')

        // this.startSubMenu()
        this.actionMenu()

    }
    
    // startSubMenu() {
        
    //     this.header.querySelector('.liRecipies').addEventListener('click', () => {
    //         this.header.querySelector('.liRecipies ul').classList.toggle('hidden');
    //     });
        
    // }
    
    actionMenu() {
        this.btnOpenMenu.addEventListener('click', () => {
            this.btnOpenMenu.classList.toggle('active')
            this.menu.classList.toggle('active')
            this.header.querySelector('.liRecipies ul').classList.add('hidden');
        })

        // this.menu.querySelectorAll('.hasSubMenu').forEach(item => {
        //     item.addEventListener('click', () => {
        //         const submenu = item.nextElementSibling;
        //         const button = item.querySelector('button');
        //         const isExpanded = button.getAttribute('aria-expanded') === 'true';

        //         // Fecha todos
        //         this.menu.querySelectorAll('.hasSubMenu').forEach(subItem => {
        //             subItem.classList.remove('active');
        //             subItem.nextElementSibling.classList.remove('active');
        //             subItem.querySelector('button').setAttribute('aria-expanded', false);
        //         });

        //         // Se o item clicado não estava expandido, ativa ele
        //         if (!isExpanded) {
        //             item.classList.add('active');
        //             submenu.classList.add('active');
        //             button.setAttribute('aria-expanded', true);
        //         }
        //     });
        // });
    }

}

new Header();